#
# Discussion specific UI bindings.
#

$ ->
  # Use mustache template formatting for underscore templates
  _.templateSettings = {
    interpolate: /\{\{(.+?)\}\}/g
  }

  # TODO: Refactor
  # It would likely be better to refactor this into a
  # common ujs endpoint for all modals and
  # consolidate with BetterModals.
  injectModal = (data, templateId, modalId) ->
    modalHtml = _.template($(templateId).html())(data)

    # add modal to DOM
    if $(modalId).length > 0
      $(modalId).replaceWith(modalHtml)
    else
      $('body').append(modalHtml)

    # show modal
    App.uiModal.open( $(modalId) )
    
    # Init validation
    $(modalId).find("form").parsley()
    return

  CharacterCounter.init()

  # Frontend UI events
  # ------------------------
  #
  $('#discuss')

    #
    # Block submit if comment field is empty.
    # 
    .on "click", "[data-behavior=submit-response]", (e) ->
      $form = $(this).closest('#new_comment')
      $commentField = $form.find('[data-behavior=submit-response]').first()
      if !$.trim($commentField.val())
        e.preventDefault();
        parent.find('.alert').show(400)

    #
    # hide comment form
    #
    .on "click", "[data-behavior=cancel-form]", (e) ->
      e.preventDefault()
      $(this).closest('[data-cancel-form]').remove()
      $('#discuss').find('.join').removeClass('hide')
      $('.oratorStart').show()

    #
    # flag a discussion or response
    #
    .on "click", "[data-behavior=modal-open-flag]", (e) ->
      if !$(this).find('.flag').hasClass('flagged')
        injectModal($(this).data(), '#modalFlagTemplate', '#modalFlag')

    #
    # remove a discussion or response
    #
    .on "click", "[data-behavior=modal-open-disccusions-remove]", (e) ->
      injectModal($(this).data(), '#modalDiscussionsRemoveTemplate', '#modalDiscussionsRemove')

      # automatically set removal reason for self-owned discussions.
      if $(this).data('owner') == true
        $('#modalDiscussionsRemove')
          .addClass('owned')
          .find('.radio-buttons').hide()
          .find('#discussion-owned').click()